import findIndex from 'lodash/findIndex';
import map from 'lodash/map';
import size from 'lodash/size';
import createPromiseThunk from "~/rx/lib/createPromiseThunk";
import fetchModelTableResults from '~/rx/lib/fetchTableResults';
import {defaultTableResults} from "~/config";
import createModelApi from "~/backend/modelApi";
import {
    getFieldData, getFieldValues, getItemId, getModelName, getValueAdaptData,
    getValueAdaptSources
} from "~/stateGetter";
import {mockupCancel} from "~/data/cancelToken";
import {arrayed} from "mythil/array";
import {modify} from "mythil/object";
import {
    constraintValues, normalizeValueDependencies, presentConstraintValues,
    presentFieldValue
} from "~/statePresenter";
import identify from "~/identify";
import authenticatedRequest from "~/backend/authenticatedRequest";

const fieldOptions = createPromiseThunk({
    func: ({cancel = mockupCancel, modelId, inputType, fields, getState, getConfig, dispatch}) => {
        let state = getState(),
            modelName = getModelName(state, modelId),
            modelApi = createModelApi(
                getConfig().baseUrl,
                modelName,
                (foo) => authenticatedRequest(foo, dispatch)
            );

        let props = {
                ...getValueAdaptData(state, modelId),
                ...getValueAdaptSources(state, modelId)
            };

        fields = fields.map((field) => {
            let storeField = getFieldData(state, modelId, inputType, field.field);
            let constraints = null;

            if(size(storeField.constraints) > 0) {
                constraints = presentConstraintValues(storeField.inputType, storeField.constraints, props)
            }

            return {
                ...field,
                constraints,
                modelId: inputType === identify.EDITFIELD ? getItemId(state, modelId) : null,
                type: inputType,
                maxOptions: storeField.maxOptions,
            }
        });

        return modelApi.fetchOptions(fields, cancel);
    },
    name: 'fieldOptions',
    defaultValue: {},
    actions: {
        setInvalidated: (fieldName, modelId, inputType) => ({
            type: fieldOptions.types.INVALIDATED,
            fieldName,
            modelId,
            inputType,
        }),
    }
});

let execute = fieldOptions.execute;
fieldOptions.execute = (modelId, inputType, fieldsOrField, cancelToken) => {
    let fields = arrayed(fieldsOrField);

    return execute(
        {modelId, inputType, fields, cancelToken},
        {modelId, fieldNames: map(fields, 'field'), inputType}
    );
};

let reduce = fieldOptions.reduce;
fieldOptions.reduce = (state, fieldName, action) => {
    switch(action.type) {
        case fieldOptions.types.SUCCESS:
            return {
                ...state,
                status: identify.STATUS_SUCCESS,
                finished_at: Date.now(),
                value: action.value[fieldName]
            };
        case fieldOptions.types.INVALIDATED: {
            if (fieldName !== action.fieldName) return state;
            state = {
                ...state,
                invalidated_at: Date.now(),
                status:  identify.STATUS_INVALIDATED,
            }
            return state;
        }
        default:
            return reduce(state, action);
    }
};

fieldOptions.reduceAutocompleteValue = (state, field, action) => {
    switch(action.type) {
        case fieldOptions.types.SUCCESS:
            // if fetched options do not include current value empty value or select the first item
            let options = action.value[field.name];

            if(field.hasMultipleValues) {
                let existingValues = state.value.filter((value) => {
                    return findIndex(options, { value }) > -1;
                });

                return {
                    ...state,
                    value: existingValues
                };
            } 


            if(findIndex(options, { value: state.value }) < 0) {
                return {
                    ...state,
                    value: null
                };
            }


            break;
    }

    return state;
};

const reduceAutocompleteOptions = fieldOptions.reduce,
    reduceAutocompleteValue = fieldOptions.reduceAutocompleteValue,
    FIELD_OPTION_TYPES = fieldOptions.types,
    fetchFieldOptions = fieldOptions.execute,
    setAutoCompleteInvalidated = fieldOptions.actions.setInvalidated;


export {
    FIELD_OPTION_TYPES,
    reduceAutocompleteOptions,
    reduceAutocompleteValue,
    fetchFieldOptions,
    setAutoCompleteInvalidated
}